var _rect, _g, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlayBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 326,
    height: 96,
    viewBox: "0 0 326 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Get it on Google Play",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 323,
    height: 93,
    rx: 12,
    fill: "#000000",
    stroke: "#A6A6A6",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(22, 22) scale(2.1667)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M3 20.5V3.5C3 2.91 3.34 2.39 3.84 2.15L13.69 12L3.84 21.85C3.34 21.6 3 21.09 3 20.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M16.81 15.12L6.05 21.34L14.54 12.85L16.81 15.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M20.16 10.81C20.5 11.08 20.75 11.5 20.75 12C20.75 12.5 20.53 12.9 20.18 13.18L17.89 14.5L15.39 12L17.89 9.5L20.16 10.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M6.05 2.66L16.81 8.88L14.54 11.15L6.05 2.66Z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 40,
    fill: "#ffffff",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13,
    letterSpacing: 0.6
  }, "GET IT ON")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 68,
    fill: "#ffffff",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 26,
    fontWeight: 700
  }, "Google Play")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBadge);
export default __webpack_public_path__ + "static/media/google-play-badge.b82fb57642f1c6b1f311232345e359ea.svg";
export { ForwardRef as ReactComponent };